import React from "react"
import Slider from "react-slick"
import { datalayerProduct } from "../../../shared/utils/datalayerProducts"
import { withOutScript } from "../../../shared/utils/formatString"
import { siteUrl } from "../../../shared/utils/siteUrl"
import { removeDoubleSlash } from "../../../shared/utils/urlUril"
import "./section-products-outstanding.scss"

const SectionProductsOutstanding = ({ contentInfo, mobile }) => {
  const urlRedirect = siteUrl + "/productos/"

  const listItems = contentInfo.productosDestacados.map((info, index) => {
    if (process.env.LOCALE === "es-AR" && info.categoria === "maternidad") {
      //Specify redirect for Argentina
      return (
        <a
          className={"f-carousel-product-pos-" + index}
          key={index}
          href={urlRedirect + info.categoria}
          onClick={() => {
            datalayerProduct({
              subCategory: withOutScript(info.categoria),
              label: info.titulo,
            })
          }}
        >
          <div className="f-section-product-item">
            <img
              className="f-section-product-item-img"
              loading="lazy"
              src={info.imagenSubcategoria.file.url}
              alt={info.imagenSubcategoria.description}
            />
            <h3 className="f-product-title">{info.titulo}</h3>
            <label className="f-product-description">
              {info.descripcionSubcategoria.descripcionSubcategoria}
            </label>
          </div>
        </a>
      )
    } else {
      return (
        <a
          className={"f-carousel-product-pos-" + index}
          key={index}
          href={urlRedirect + removeDoubleSlash(info.categoria + "/" + info.slug)}
          onClick={() => {
            datalayerProduct({
              subCategory: withOutScript(info.categoria),
              label: info.titulo,
            })
          }}
        >
          <div className="f-section-product-item">
            <img
              className="f-section-product-item-img"
              loading="lazy"
              src={info.imagenSubcategoria.file.url}
              alt={info.imagenSubcategoria.description}
            />
            <h3 className="f-product-title">{info.titulo}</h3>
            <label className="f-product-description">
              {info.descripcionSubcategoria.descripcionSubcategoria}
            </label>
          </div>
        </a>
      )
    }
  })
  const NextArrow = props => {
    const { onClick } = props
    return <span className="f-slider-home-products-next" onClick={onClick} />
  }
  const PrevArrow = props => {
    const { onClick } = props
    return <span className="f-slider-home-products-prev" onClick={onClick} />
  }

  var settings = {
    dots: true,
    infinite: true,
    slidesToShow: mobile ? 1 : listItems.length <= 3 ? 1 : 3,
    slidesToScroll: 1,
    centerMode: true,
    focusOnSelect: true,
    initialSlide: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }

  return (
    <Slider {...settings} className="f-section-products-outstanding">
      {listItems}
    </Slider>
  )
}

export default SectionProductsOutstanding
